[
  {
    "draftJersey": 251,
    "role": "PT",
    "name": "Brandon Muñiz",
    "foot": "left",
    "height": 185,
    "birthdate": "16/04/2002",
    "country": "MEX",
    "macros": {
      "reflexes": 91,
      "diving": 78,
      "duels": 71,
      "passing": 84,
      "handling": 51,
      "anticipation": 77,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/251.jpg",
    "profileYtVideoId": "D73ykNRcR50",
    "matchYtVideoId": "y_m3QK10K4M"
  },
  {
    "draftJersey": 252,
    "role": "PT",
    "name": "Bernardo Lugo",
    "foot": "right",
    "height": 190,
    "birthdate": "06/12/2002",
    "country": "MEX",
    "macros": {
      "reflexes": 74,
      "diving": 69,
      "duels": 76,
      "passing": 80,
      "handling": 81,
      "anticipation": 77,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/252.jpg",
    "profileYtVideoId": "b2RVoGC5lBI",
    "matchYtVideoId": "mbhbzsUw1AA"
  },
  {
    "draftJersey": 253,
    "role": "PT",
    "name": "Paul Cruz",
    "foot": "right",
    "height": 177,
    "birthdate": "29/01/1998",
    "country": "MEX",
    "macros": {
      "reflexes": 85,
      "diving": 78,
      "duels": 76,
      "passing": 67,
      "handling": 56,
      "anticipation": 71,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/253.jpg",
    "profileYtVideoId": "AWzDUfFDINk",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 254,
    "role": "PT",
    "name": "Edgar Álvarez",
    "foot": "right",
    "height": 170,
    "birthdate": "04/08/1998",
    "country": "MEX",
    "macros": {
      "reflexes": 81,
      "diving": 83,
      "duels": 82,
      "passing": 83,
      "handling": 77,
      "anticipation": 80,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/254.jpg",
    "profileYtVideoId": "L2lhaDN2Whk",
    "matchYtVideoId": "y_m3QK10K4M"
  },
  {
    "draftJersey": 256,
    "role": "PT",
    "name": "Omar Láscari",
    "foot": "right",
    "height": 196,
    "birthdate": "11/04/1996",
    "country": "MEX",
    "macros": {
      "reflexes": 85,
      "diving": 78,
      "duels": 66,
      "passing": 83,
      "handling": 61,
      "anticipation": 76,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/256.jpg",
    "profileYtVideoId": "AfD3elFX1pw",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 257,
    "role": "PT",
    "name": "Jesús González",
    "foot": "right",
    "height": 187,
    "birthdate": "22/05/1991",
    "country": "MEX",
    "macros": {
      "reflexes": 91,
      "diving": 78,
      "duels": 76,
      "passing": 62,
      "handling": 81,
      "anticipation": 75,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/257.jpg",
    "profileYtVideoId": "vtI-HMzpwb8",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 259,
    "role": "PT",
    "name": "Carlos López",
    "foot": "right",
    "height": 186,
    "birthdate": "22/03/1991",
    "country": "MEX",
    "macros": {
      "reflexes": 92,
      "diving": 88,
      "duels": 72,
      "passing": 82,
      "handling": 82,
      "anticipation": 82,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/259.jpg",
    "profileYtVideoId": "z10Cjekwy30",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 260,
    "role": "PT",
    "name": "Luis Nava",
    "foot": "right",
    "height": 180,
    "birthdate": "18/11/1993",
    "country": "MEX",
    "macros": {
      "reflexes": 73,
      "diving": 72,
      "duels": 80,
      "passing": 71,
      "handling": 75,
      "anticipation": 74,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/260.jpg",
    "profileYtVideoId": "kGlv8IqfuP0",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 263,
    "role": "PT",
    "name": "Franco Colagrossi",
    "foot": "right",
    "height": 178,
    "birthdate": "27/07/1990",
    "country": "ARG",
    "macros": {
      "reflexes": 79,
      "diving": 76,
      "duels": 65,
      "passing": 64,
      "handling": 75,
      "anticipation": 71,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/263.jpg",
    "profileYtVideoId": "GqcunPUDPqE",
    "matchYtVideoId": "r_n_Akrdb8w"
  },
  {
    "draftJersey": 264,
    "role": "PT",
    "name": "Ricardo Bustos",
    "foot": "right",
    "height": 184,
    "birthdate": "19/06/2002",
    "country": "MEX",
    "macros": {
      "reflexes": 69,
      "diving": 92,
      "duels": 67,
      "passing": 81,
      "handling": 82,
      "anticipation": 78,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/264.jpg",
    "profileYtVideoId": "0J_cuFWyD-A",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 265,
    "role": "PT",
    "name": "Óscar Rodríguez",
    "foot": "right",
    "height": 178,
    "birthdate": "23/09/1993",
    "country": "MEX",
    "macros": {
      "reflexes": 90,
      "diving": 90,
      "duels": 65,
      "passing": 71,
      "handling": 60,
      "anticipation": 75,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/265.jpg",
    "profileYtVideoId": "-3A_8at6aS8",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 266,
    "role": "PT",
    "name": "Juan Jiménez",
    "foot": "right",
    "height": 184,
    "birthdate": "28/02/1998",
    "country": "MEX",
    "macros": {
      "reflexes": 69,
      "diving": 82,
      "duels": 91,
      "passing": 74,
      "handling": 86,
      "anticipation": 79,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/266.jpg",
    "profileYtVideoId": "UzPrLgGPgQo",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 267,
    "role": "PT",
    "name": "Patricio Navarro",
    "foot": "right",
    "height": 174,
    "birthdate": "04/01/2005",
    "country": "MEX",
    "macros": {
      "reflexes": 85,
      "diving": 78,
      "duels": 81,
      "passing": 67,
      "handling": 86,
      "anticipation": 77,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/267.jpg",
    "profileYtVideoId": "kTQYIyrabyY",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 268,
    "role": "PT",
    "name": "Tirso Trueba",
    "foot": "left",
    "height": 180,
    "birthdate": "11/06/1996",
    "country": "MEX / ESP",
    "macros": {
      "reflexes": 90,
      "diving": 81,
      "duels": 70,
      "passing": 73,
      "handling": 75,
      "anticipation": 78,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/268.jpg",
    "profileYtVideoId": "cAOftqnzA18",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 269,
    "role": "PT",
    "name": "Eduardo Quiroga",
    "foot": "right",
    "height": 189,
    "birthdate": "03/10/1999",
    "country": "MEX",
    "macros": {
      "reflexes": 81,
      "diving": 74,
      "duels": 77,
      "passing": 82,
      "handling": 92,
      "anticipation": 81,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/269.jpg",
    "profileYtVideoId": "SZeSaixtaHY",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 271,
    "role": "PT",
    "name": "Yosgart Gutiérrez",
    "foot": "right",
    "height": 189,
    "birthdate": "15/03/1981",
    "country": "MEX",
    "macros": {
      "reflexes": 92,
      "diving": 79,
      "duels": 82,
      "passing": 80,
      "handling": 62,
      "anticipation": 78,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/271.jpg",
    "profileYtVideoId": "gl8a7F-tbD0",
    "matchYtVideoId": "dOXzJxysnW4"
  },
  {
    "draftJersey": 272,
    "role": "PT",
    "name": "Ariel Pérez",
    "foot": "right",
    "height": 187,
    "birthdate": "06/10/1987",
    "country": "ARG / MEX",
    "macros": {
      "reflexes": 68,
      "diving": 81,
      "duels": 55,
      "passing": 69,
      "handling": 70,
      "anticipation": 69,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/272.jpg",
    "profileYtVideoId": "jKUVEccOLTU?si=s79GfS4XfVZqZnM5",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 273,
    "role": "PT",
    "name": "Diego Arriaga",
    "foot": "right",
    "height": 170,
    "birthdate": "12/08/1988",
    "country": "MEX",
    "macros": {
      "reflexes": 74,
      "diving": 82,
      "duels": 81,
      "passing": 84,
      "handling": 81,
      "anticipation": 81,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/273.jpg",
    "profileYtVideoId": "d_l9eOq2NbU",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 274,
    "role": "PT",
    "name": "José Gómez",
    "foot": "right",
    "height": 178,
    "birthdate": "26/06/1989",
    "country": "MEX",
    "macros": {
      "reflexes": 79,
      "diving": 85,
      "duels": 80,
      "passing": 83,
      "handling": 65,
      "anticipation": 80,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/274.jpg",
    "profileYtVideoId": "GpVVxVY9ycM",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 275,
    "role": "PT",
    "name": "Moisés Dabbah",
    "foot": "right",
    "height": 180,
    "birthdate": "25/07/1997",
    "country": "MEX",
    "macros": {
      "reflexes": 74,
      "diving": 87,
      "duels": 91,
      "passing": 80,
      "handling": 81,
      "anticipation": 82,
      "average": 83
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/275.jpg",
    "profileYtVideoId": "SJkrZ-bnMt4",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 276,
    "role": "PT",
    "name": "Diego Almazán",
    "foot": "right",
    "height": 188,
    "birthdate": "04/07/2002",
    "country": "MEX",
    "macros": {
      "reflexes": 79,
      "diving": 85,
      "duels": 65,
      "passing": 71,
      "handling": 70,
      "anticipation": 75,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/276.jpg",
    "profileYtVideoId": "oZt8TXSX5Is",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 278,
    "role": "PT",
    "name": "Saúl Reyes",
    "foot": "right",
    "height": 190,
    "birthdate": "27/02/2005",
    "country": "MEX",
    "macros": {
      "reflexes": 90,
      "diving": 76,
      "duels": 70,
      "passing": 79,
      "handling": 80,
      "anticipation": 80,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/278.jpg",
    "profileYtVideoId": "o-bcUWXUHe0",
    "matchYtVideoId": "dOXzJxysnW4"
  },
  {
    "draftJersey": 279,
    "role": "PT",
    "name": "Carlos Durán",
    "foot": "right",
    "height": 175,
    "birthdate": "12/05/2003",
    "country": "MEX",
    "macros": {
      "reflexes": 74,
      "diving": 82,
      "duels": 71,
      "passing": 75,
      "handling": 76,
      "anticipation": 75,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/279.jpg",
    "profileYtVideoId": "8RM45Gw2KD0",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 280,
    "role": "PT",
    "name": "Pedro Arroyo",
    "foot": "right",
    "height": 170,
    "birthdate": "25/6/1999",
    "country": "MEX",
    "macros": {
      "reflexes": 74,
      "diving": 73,
      "duels": 76,
      "passing": 62,
      "handling": 76,
      "anticipation": 70,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/280.jpg",
    "profileYtVideoId": "n_0SyhOYCKQ",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 282,
    "role": "PT",
    "name": "Óscar Medina",
    "foot": "right",
    "height": 186,
    "birthdate": "15/10/1993",
    "country": "MEX",
    "macros": {
      "reflexes": 81,
      "diving": 84,
      "duels": 78,
      "passing": 76,
      "handling": 93,
      "anticipation": 80,
      "average": 83
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/282.jpg",
    "profileYtVideoId": "YkoxHVki32Y",
    "matchYtVideoId": "_hSNDu_vKG4"
  },
  {
    "draftJersey": 283,
    "role": "PT",
    "name": "Jonathan Mateos",
    "foot": "right",
    "height": 182,
    "birthdate": "23/09/1999",
    "country": "MEX",
    "macros": {
      "reflexes": 91,
      "diving": 91,
      "duels": 71,
      "passing": 86,
      "handling": 76,
      "anticipation": 84,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/283.jpg",
    "profileYtVideoId": "ont7Mw108wo",
    "matchYtVideoId": "OIwnKL8Zl5o"
  },
  {
    "draftJersey": 285,
    "role": "PT",
    "name": "Eugenio Santoyo",
    "foot": "right",
    "height": 177,
    "birthdate": "13/09/2005",
    "country": "MEX",
    "macros": {
      "reflexes": 68,
      "diving": 72,
      "duels": 70,
      "passing": 73,
      "handling": 75,
      "anticipation": 72,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/285.jpg",
    "profileYtVideoId": "9slyfmuo9-I",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 286,
    "role": "PT",
    "name": "Jesús Carbajal",
    "foot": "right",
    "height": 187,
    "birthdate": "31/07/1996",
    "country": "MEX",
    "macros": {
      "reflexes": 85,
      "diving": 85,
      "duels": 75,
      "passing": 76,
      "handling": 75,
      "anticipation": 79,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/286.jpg",
    "profileYtVideoId": "28QsgobJRE4",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 288,
    "role": "PT",
    "name": "Julio Torres",
    "foot": "right",
    "height": 180,
    "birthdate": "02/05/2001",
    "country": "MEX",
    "macros": {
      "reflexes": 85,
      "diving": 82,
      "duels": 86,
      "passing": 77,
      "handling": 76,
      "anticipation": 81,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/288.jpg",
    "profileYtVideoId": "aiP3zXvuMpY",
    "matchYtVideoId": "OIwnKL8Zl5o"
  },
  {
    "draftJersey": 290,
    "role": "PT",
    "name": "James Hernández",
    "foot": "right",
    "height": 185,
    "birthdate": "28/11/2005",
    "country": "MEX",
    "macros": {
      "reflexes": 85,
      "diving": 87,
      "duels": 81,
      "passing": 74,
      "handling": 81,
      "anticipation": 80,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/290.jpg",
    "profileYtVideoId": "Dpe40dvvos8",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 291,
    "role": "PT",
    "name": "Silverio Rocchi",
    "foot": "right",
    "height": 190,
    "birthdate": "16/07/1988",
    "country": "MEX / ITA",
    "macros": {
      "reflexes": 75,
      "diving": 75,
      "duels": 78,
      "passing": 82,
      "handling": 88,
      "anticipation": 78,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/291.jpg",
    "profileYtVideoId": "b-gJ8kwsTbk",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 292,
    "role": "PT",
    "name": "Erik Lugo",
    "foot": "right",
    "height": 187,
    "birthdate": "27/03/2000",
    "country": "MEX",
    "macros": {
      "reflexes": 92,
      "diving": 70,
      "duels": 82,
      "passing": 80,
      "handling": 82,
      "anticipation": 80,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/292.jpg",
    "profileYtVideoId": "7bSlRQgIPUk",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 294,
    "role": "PT",
    "name": "Ricardo Ferriño",
    "foot": "right",
    "height": 180,
    "birthdate": "07/08/1991",
    "country": "MEX",
    "macros": {
      "reflexes": 80,
      "diving": 87,
      "duels": 81,
      "passing": 80,
      "handling": 71,
      "anticipation": 79,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/294.jpg",
    "profileYtVideoId": "Vr7AxclH9hQ",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 296,
    "role": "PT",
    "name": "Daniel Maldonado",
    "foot": "right",
    "height": 185,
    "birthdate": "25/04/1996",
    "country": "MEX",
    "macros": {
      "reflexes": 69,
      "diving": 78,
      "duels": 81,
      "passing": 69,
      "handling": 66,
      "anticipation": 72,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/296.jpg",
    "profileYtVideoId": "CoL7j5zpe8s",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 301,
    "role": "PT",
    "name": "Eli Saadia",
    "foot": "right",
    "height": 189,
    "birthdate": "19/6/1988",
    "country": "MEX",
    "macros": {
      "reflexes": 80,
      "diving": 82,
      "duels": 76,
      "passing": 75,
      "handling": 71,
      "anticipation": 76,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/301.jpg",
    "profileYtVideoId": "-pPLwCdIJg4",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 302,
    "role": "PT",
    "name": "Hugo Murga",
    "foot": "right",
    "height": 185,
    "birthdate": "19/10/1999",
    "country": "MEX",
    "macros": {
      "reflexes": 74,
      "diving": 82,
      "duels": 76,
      "passing": 86,
      "handling": 81,
      "anticipation": 86,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/302.jpg",
    "profileYtVideoId": "lr2j09TeL1M",
    "matchYtVideoId": "AjkPh6mIRZs"
  }
]
